import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  FormControlLabel,
  FormControl,
  Autocomplete,
} from "@material-ui/core";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { makeStyles } from "@material-ui/styles";
import { Checkbox } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import VenderCode from "../Invoices/NewInvoice/Dropdowns/VenderCode";
import Heading from "../../StyledComponents/Heading/Heading";


import moment from "moment";


import { dashboardStyle } from "../Invoices/Components/InvoiceDetails/style.js";

import getParameterByName from "../../Functions/functions";
import isOldDateValidate from "../../Functions/isOldDateValidate.js";
import isFutureDate from "../../Functions/isFutureDate";

import {formatDateTimeForBackend} from "../../Functions"
const useStyles = makeStyles(dashboardStyle);

const VFPostingDetail= ({
    newFormState,
    setNewFormState,
    multipleData,
    changeHandler,
    disabled,
    alignForAttachment,
  
}) => {
  const classes = useStyles();
  const roleName = getParameterByName("roleName"); // get role name for show attachment
  const invoiceEdit = getParameterByName("edit"); // get form url

  const [openWarningBox, setOpenWarningBox] = useState(false);
  const [currentStateForDeleteion, setCurrentStateForDeleteion] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  const [attachError, setAttachError] = useState("");
  const [docError, setDocError] = useState("");
  const [deleteLoader, setdeleteLoader] = useState(false);
  const [attachmentFile_UI, setAttchmentFile_UI] = useState([]);
  const [openInvalidWarningDate, setOpenInvalidWarningDate] = useState(false);

 
  const [warningFlag, setWarningFlag] = useState(false);
  const Stylecolor = {
    color: "black",
    fonStyle:"bold"
  };
  const spanStyle = {
      color:"#999" ,fontSize:"14px"
    
    }
 
  return (

    
    <Grid container direction={'row'} spacing={3} style={{ marginTop: "4px" }}>
    <Grid
    item
    xs={12}
    sm={12}
    md={12}
    lg={12}
   >
   <Heading title="Posting Detail" />
   
   </Grid>
       
        {/* documents date */}
        <Grid
        item
        xs={12}
        sm={12}
        md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
        style={{ paddingRight: "18px" }}
       >
        <Typography variant="h5" style={Stylecolor}>
          Documents Date:{` `}
          <span style={spanStyle}>{moment(newFormState?.posting_Date).format("YYYY-MM-DD")}</span>
        </Typography>
       {/* <input
          className={classes.inputField}
          name="document_date"
          type="date"
          max="9999-12-31"
          disabled={disabled}
          style={{
            color:  "#B4B4B4" ,
            backgroundColor: "white",
          }}
  //  value={moment(newFormState?.document_date).format("YYYY-MM-DD")} 
  value={moment(newFormState?.posting_Date).format("YYYY-MM-DD")}//  saleem bhai said that posting date is also consider as documents date
   //  value={newFormState?.invoice_Date}
        //   onChange={changeHandler}
          onInput={(newValue) => {
            isOldDateValidate(
              formatDateTimeForBackend(newValue),
              setOpenInvalidWarningDate,
              setNewFormState
            );
            setNewFormState((formState) => ({
              ...formState,
              document_date: formatDateTimeForBackend(newValue),
            }));
            isFutureDate(
              formatDateTimeForBackend(newValue),
              setNewFormState,
              "document_date"
            );
          }}
        />*/}
 </Grid>

 {/*documents refrence  */}

 <Grid
 item
 xs={12}
 sm={12}
 md={alignForAttachment ? 6 : 3}
 lg={alignForAttachment ? 6 : 3}
>
 <Typography variant="h5" style={Stylecolor}>
   
  Documents Reference:{` `}
  <span style={spanStyle}>{newFormState?.documents_Reference}</span>
 </Typography>

{/* <TextField
   fullWidth
   size="small"
   name="documents_Reference"
  value={newFormState?.documents_Reference}
   sx={{
     // width: "70%",
     "& legend": { display: "none" },
     "& fieldset": { top: 0 },
   }}
   id="outlined-basic"
   variant="outlined"
   disabled={disabled}
   required
//    onChange={changeHandler}
   inputProps={{ maxLength: 16 }}
  />
*/}
</Grid>
 {/* Invoice Description */}
 <Grid
 item
 xs={12}
 sm={12}
 md={alignForAttachment ? 6 : 3}
 lg={alignForAttachment ? 6 : 3}
>
 <Typography variant="h5" style={Stylecolor}>
    Invoice Description:{` `}
   <span style={spanStyle}>{newFormState?.invoice_Desc}</span>
 </Typography>
{/* <TextField
   fullWidth
   size="small"
   sx={{
     // width: "70%",
     "& legend": { display: "none" },
     "& fieldset": { top: 0 },
   }}
   id="outlined-basic"
   name="invoice_Desc"
   value={newFormState?.invoice_Desc}
  //  value={newFormState?.Invoice_Desc}

   variant="outlined"
   disabled={disabled}
   required
  //  onChange={changeHandler}
   FormHelperTextProps={{
     className: classes.helperText,
   }}
  
  />*/}
</Grid>

 {/* Invoice Amount */}
 <Grid
 item
 xs={12}
 sm={12}
 md={alignForAttachment ? 6 : 3}
 lg={alignForAttachment ? 6 : 3}
>
 <Typography variant="h5" style={Stylecolor}>
   
   Invoice Amount:{` `}
   <span style={spanStyle}>{newFormState?.invoice_Amount}</span>
 </Typography>
 {/*<TextField
   fullWidth
   size="small"
   sx={{
     // width: "70%",
     "& legend": { display: "none" },
     "& fieldset": { top: 0 },
   }}
   id="outlined-basic"
   variant="outlined"
   type="number"
   name="invoice_Amount"
  //  value={newFormState?.invoice_Details?.Invoice_Amount}
  value={newFormState?.invoice_Amount}

   disabled={disabled}
   required
   InputProps={{
     inputProps: { min: 0, step: 0.00001 },
   }}
//    onChange={changeHandler}
  />*/}
</Grid>
 {/* Vendor */}
 <Grid
 item
 xs={12}
 sm={12}
 md={alignForAttachment ? 6 : 3}
 lg={alignForAttachment ? 6 : 3}
>
 <Typography variant="h5" style={Stylecolor}>
   
   Vendor:{` `}
   <span style={spanStyle}>{newFormState?.vendor_Name === ""}</span>
 </Typography>

{/* <TextField
   fullWidth
   size="small"
   disabled={disabled}
   // disabled={newFormState?.vendor_Code != null ? true : false}
   sx={{
     // width: "70%",
     "& legend": { display: "none" },
     "& fieldset": { top: 0 },
   }}
   id="outlined-basic"
   variant="outlined"
   name="vendor_Code"
   required={newFormState?.vendor_Name === ""}
   value={newFormState?.vendor_Name}

//    onChange={changeHandler}
  />*/}
</Grid>
 {/* Posting Date */}
 <Grid
 item
 xs={12}
 sm={12}
 md={alignForAttachment ? 6 : 3}
 lg={alignForAttachment ? 6 : 3}
 style={{ paddingRight: "18px" }}
>
 <Typography variant="h5" style={Stylecolor}>
   
   Posting Date:{` `}
   <span style={spanStyle}>{moment(newFormState?.posting_Date).format("YYYY-MM-DD")}</span>
 </Typography>


{ /*<input
   className={classes.inputField}
   name="posting_Date"
   type="date"
   max="9999-12-31"
   disabled={disabled}
   style={{
     color: "#B4B4B4" ,
     backgroundColor:  "white",
   }}
//    onChange={changeHandler}
   onInput={(newValue) => {
     isOldDateValidate(
       formatDateTimeForBackend(newValue),
       setOpenInvalidWarningDate,
       setNewFormState
     );
     setNewFormState((formState) => ({
       ...formState,
       posting_Date: formatDateTimeForBackend(newValue),
     }));
     isFutureDate(
       formatDateTimeForBackend(newValue),
       setNewFormState,
       "posting_Date"
     );
   }}
  //  value={moment(newFormState?.invoice_Details?.Posting_Date).format("YYYY-MM-DD")}
   value={moment(newFormState?.posting_Date).format("YYYY-MM-DD")}

  />*/}
</Grid>

<Grid
item
xs={12}
sm={12}
md={alignForAttachment ? 6 : 3}
lg={alignForAttachment ? 6 : 3}
>
<Typography variant="h5" style={Stylecolor}>
  
  Currency:{` `}
  <span style={spanStyle}>{newFormState?.currency || newFormState?.Currency}</span>
</Typography>
{/*<Autocomplete
  id="submitter_role"
  options={multipleData?.currency || []}
  defaultValue={[multipleData?.currency[0]]}
  size="small"
  disabled={disabled}
  value={{
    ReferenceCode:
    newFormState?.currency || newFormState?.Currency || "",
  }}
  // value={formState.invoice_Payment}
  getOptionLabel={(option) =>
    (option !== "" && `${option?.ReferenceCode}`) || ""
  }
  // loading={rolesLoading}
  onChange={(event, newValue) => {
    const e = {
      target: {
        name: "currency",
        value: newValue?.ReferenceCode,
      },
    };

    // changeHandler(e);
  }}
  renderInput={(params) => (
    <TextField {...params} type="text" name="" label="" required />
  )}
  />*/}
</Grid>

<Grid
item
xs={12}
sm={12}
md={alignForAttachment ? 6 : 3}
lg={alignForAttachment ? 6 : 3}
>
<Typography variant="h5" style={Stylecolor}>
  
 Documents Number:{` `}
 <span style={spanStyle}>{newFormState?.document_No}</span>
</Typography>

{/*<TextField
  fullWidth
  size="small"
  name="invoice_No"
  value={newFormState?.document_No}
  sx={{
    // width: "70%",
    "& legend": { display: "none" },
    "& fieldset": { top: 0 },
  }}
  id="outlined-basic"
  variant="outlined"
  disabled={disabled}
  required
  // onChange={changeHandler}
  inputProps={{ maxLength: 16 }}
/>
*/}
</Grid>

{/* fiscal year*/}

<Grid
item
xs={12}
sm={12}
md={alignForAttachment ? 6 : 3}
lg={alignForAttachment ? 6 : 3}
>
<Typography variant="h5" style={Stylecolor}>
  
 Fiscal Year:{` `}
 <span style={spanStyle}>{newFormState?.fiscal_Year}</span>
</Typography>

{/*<TextField
  fullWidth
  size="small"
  name="invoice_No"
  value={newFormState?.fiscal_Year}
  sx={{
    // width: "70%",
    "& legend": { display: "none" },
    "& fieldset": { top: 0 },
  }}
  id="outlined-basic"
  variant="outlined"
  disabled={disabled}
  required
  // onChange={changeHandler}
  inputProps={{ maxLength: 16 }}
/>*/}
</Grid>
    {/*final amount*/} 
    
    <Grid
    item
    xs={12}
    sm={12}
    md={alignForAttachment ? 6 : 3}
    lg={alignForAttachment ? 6 : 3}
   >
    <Typography variant="h5" style={Stylecolor}>
      
      Final Invoice Amount:{` `}
      <span style={spanStyle}>{newFormState?.final_Invoice_Amount}</span>
    </Typography>
   {/* <TextField
      fullWidth
      size="small"
      sx={{
        // width: "70%",
        "& legend": { display: "none" },
        "& fieldset": { top: 0 },
      }}
      id="outlined-basic"
      variant="outlined"
      type="number"
      name="invoice_Amount"
      value={newFormState?.final_Invoice_Amount}
      disabled={disabled}
      required
      InputProps={{
        inputProps: { min: 0, step: 0.00001 },
      }}
    //   onChange={changeHandler}
    />*/}
   </Grid>
   <Grid
 item
 xs={12}
 sm={12}
 md={alignForAttachment ? 6 : 3}
 lg={alignForAttachment ? 6 : 3}
>
 <Typography variant="h5" style={Stylecolor}>
    Invoice Description Change By Supervisor:{` `}
   <span style={spanStyle}>{newFormState?.newInvoice_Desc}</span>
 </Typography>
{/* <TextField
   fullWidth
   size="small"
   sx={{
     // width: "70%",
     "& legend": { display: "none" },
     "& fieldset": { top: 0 },
   }}
   id="outlined-basic"
   name="invoice_Desc"
   value={newFormState?.newInvoice_Desc}
  // value={newFormState?.Invoice_Desc}

   variant="outlined"
   disabled={disabled}
   required
//    onChange={changeHandler}
   FormHelperTextProps={{
     className: classes.helperText,
   }}
 
  />*/}
</Grid>
        </Grid>

  );
};

export default VFPostingDetail;
